export enum Adapter {
    Static = 'static',
    Ssr = 'ssr',
}